import { useParams } from 'react-router-dom';

import { AddCircle, Refresh } from '@mui/icons-material';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';

import Spinner from '../../common/components/Spinner';
import CreateIntegrationEventButton from './Components/CreateIntegrationEventButton';
import IntegrationEventList from './Components/IntegrationEventList';
import { useIntegrationEventsController } from './Hooks/useIntegrationEventsController';

export default function IntegrationEventDesignerView() {
	const { contextId } = useParams<{ contextId?: string }>();
	const {
		integrationEvents: events,
		createIntegrationEvent,
		loadingIntegrationEvents: loadingEvents,
		reloadIntegrationEvents,
	} = useIntegrationEventsController(contextId);

	return (
		<Stack
			direction="column"
			sx={(theme) => ({
				flexGrow: 1,
				minHeight: 0,
				px: `${theme.layout.edgeGap}px`,
				py: `${theme.layout.edgeGap}px`,
			})}
		>
			{loadingEvents && <Spinner />}
			<IntegrationEventList
				title="Event Catalog"
				subtitle="Manage and inspect your domain’s integration events and payload contracts."
				primaryAction={
					contextId ? (
						<CreateIntegrationEventButton
							onCreate={createIntegrationEvent}
							contextId={contextId}
							renderButton={(onClick) => (
								<Button variant="contained" startIcon={<AddCircle />} onClick={onClick}>
									Create Event
								</Button>
							)}
						/>
					) : undefined
				}
				utilityActions={
					<Tooltip title="Refresh events">
						<span>
							<IconButton aria-label="Refresh events" onClick={reloadIntegrationEvents} disabled={loadingEvents}>
								<Refresh />
							</IconButton>
						</span>
					</Tooltip>
				}
				integrationEvents={events}
				loading={loadingEvents}
			/>
		</Stack>
	);
}
